import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PaginationActionsUnion, PaginationActionTypes, } from './pagination.actions';
import { Pagination } from './pagination.model';

export const initialState: Pagination = {};

export const paginationReducer = (
  customLoad?: string,
  customClear?: string,
  customSuccess?: string,
) => (
  state = initialState,
  action: PaginationActionsUnion | any,
  ): Pagination => {
    if ([customClear, PaginationActionTypes.Clear].includes(action.type)) {
      state = {
        loading: false,
      };
    }

    if ([customLoad, PaginationActionTypes.Load].includes(action.type)) {
      state = {
        ...state,
        ...action.payload,
        content:
          !!action.payload.content &&
          action.payload.content.map(({ id }) => ({ id })),
        loading: true,

      };
    }

    if ([customSuccess, PaginationActionTypes.Success].includes(action.type)) {
      state = {
        ...state,
        loading: false,
      };
    }

    if (PaginationActionTypes.ChangePage === action.type) {
      state = {
        ...state,
        number: action.payload
      };
    }

    return state;
  };

export const getPagination = createFeatureSelector<Pagination>('pagination');

export const getPaginationNumber = createSelector(
  getPagination,
  (state: Pagination) => !!state && state.number,
);
